
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/[stateElection]/constituency-list",
      function () {
        return require("private-next-pages/elections/[stateElection]/constituency-list/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/[stateElection]/constituency-list"])
      });
    }
  